import IconBase from "./IconBase";

const ImageIcon = props => (
  <IconBase {...props}>
    <g transform="translate(2 2)" fill="currentColor">
      <path
        fillRule="nonzero"
        d="M3 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm0-2h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
      />
      <circle cx="5.5" cy="5.5" r="1.5" />
      <path
        fillRule="nonzero"
        d="M12.285 9.626a2 2 0 0 0-2.61.36L6.192 14H13a1 1 0 0 0 1-1v-2.245l-1.715-1.129zm3.265-.245a1 1 0 0 1 .45.835V13a3 3 0 0 1-3 3H4a1 1 0 0 1-.755-1.655l4.92-5.67a4 4 0 0 1 5.22-.72l2.165 1.426z"
      />
    </g>
  </IconBase>
);

export default ImageIcon;
